"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const blocks_1 = require("../blocks");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const SceneManager_1 = require("../managers/SceneManager");
const gsap_core_1 = require("gsap/gsap-core");
const settings_1 = require("../config/settings");
class Popup extends blocks_1.Block {
    constructor(app, animate = true) {
        super(app);
        this.zIndex = SceneManager_1.Layer.Popup;
        this.backdrop = this.makeBackdrop();
        this.background = this.makeBackground();
        this.redrawBackdrop();
        this.pivot.set(this.center.x, this.center.y);
        this.position.set(this.center.x, this.center.y);
        if (animate) {
            this.animate();
        }
    }
    animate() {
        this.scale.set(0.85);
        this.promisedTimeline(gsap_core_1.gsap.timeline().to(this, {
            ease: 'power2',
            keyframes: [
                { pixi: { scale: 1.15 } },
                { pixi: { scale: 1 } }
            ],
            duration: 0.2
        })).then();
    }
    get backgroundsettings() {
        let width, height;
        if (this.isLandscapeBox) {
            width = (this.app.screen.width * .66) / (0, Global_1.px)();
            height = (this.app.screen.height * 0.9) / (0, Global_1.px)();
        }
        else {
            width = Math.min((this.app.screen.width * 0.9) / (0, Global_1.px)(), settings_1.Settings.maxWidth);
            height = (this.app.screen.height * .66) / (0, Global_1.px)();
        }
        return {
            width: width,
            height: height,
            backgroundColor: settings_1.Settings.whiteColor,
            borderColor: settings_1.Settings.blackColor
        };
    }
    makeBackground() {
        const back = this.makeBox(this.backgroundsettings);
        return this.addChild(back);
    }
    redrawBackdrop() {
        var _a;
        (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.clear().beginFill(settings_1.Settings.whiteColor).drawRect(0, 0, this.app.screen.width, this.app.screen.height);
    }
    makeBackdrop() {
        const back = (new pixi_js_1.Graphics());
        back.alpha = 0.6;
        back.eventMode = 'static'; // Block events
        return this.addChild(back);
    }
    layout() {
        super.layout();
        this.redrawBackdrop();
        const settings = this.backgroundsettings;
        this.makeBox(settings, this.background);
        this.background.position.set(this.center.x - (0, Global_1.px)(settings.width / 2), this.center.y - (0, Global_1.px)(settings.height / 2));
    }
}
exports.Popup = Popup;
